export default {
    baseURL: 'https://api.care4myeloma.in'
}
